"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMarketingChannel = exports.isAffiliateMedium = void 0;
var types_1 = require("../types");
function isAffiliateMedium(medium) {
    return Boolean([types_1.MarketingMedium.Affiliate, types_1.MarketingMedium.Affiliates].includes(medium));
}
exports.isAffiliateMedium = isAffiliateMedium;
function getMarketingChannel(source, medium) {
    var paidSearchSource = ['google', 'bing'];
    var paidSocialSource = [
        'facebook',
        'instagram',
        'linkedin',
        'twitter',
        'tiktok',
        'snapchat',
    ];
    var CRMMedium = ['email', 'in_app', 'push_notification', 'sms'];
    var partnershipMedium = [
        'branding_partnerships',
        'add-on_partnerships',
        'edu_partnerships',
        'mno_integration',
        'strategic_partnerships',
        'growth_partnerships',
    ];
    if (isAffiliateMedium(medium)) {
        return 'Affiliates';
    }
    if (medium === 'cpc') {
        if (paidSearchSource.includes(source))
            return 'Paid Search';
        if (paidSocialSource.includes(source))
            return 'Paid Social';
        return 'Other';
    }
    if (medium === 'display') {
        return 'Display';
    }
    if (CRMMedium.includes(medium)) {
        return source === 'braze' ? 'CRM' : 'Other';
    }
    if (medium === 'influencers') {
        return 'Influencers';
    }
    if (medium === 'social') {
        return 'Organic Social';
    }
    if (medium === 'referral' || source === 'share') {
        return 'Referral';
    }
    if (medium === 'g-pays') {
        return 'Retail';
    }
    if (partnershipMedium.includes(medium)) {
        return 'Partnerships';
    }
    if (medium === 'podcasts' && source === 'radio') {
        return 'Offline Partnerships';
    }
    if (medium === 'shopping') {
        return 'Shopping';
    }
    if (medium === 'organic') {
        return 'Organic Search';
    }
    if (source === 'direct') {
        return 'Direct';
    }
    if (source === 'grover' && medium === 'refer_friend') {
        return 'Refer Friend';
    }
    return 'Other';
}
exports.getMarketingChannel = getMarketingChannel;
//# sourceMappingURL=getMarketingChannel.js.map